import React from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Close from "../../../Helpers/CloseBtn/Close";
import Button from "../../../Helpers/Button/Button";
import { useDeleteCategoryMutation } from "../../../../Redux/service/InventorySetup/InventorySetup";

const CategoryDeletePopup = ({ id, deleteType, onClose, setIsDeleted }) => {
  let [deleteCategory] = useDeleteCategoryMutation();

  const Remove = async () => {
    await deleteCategory(id).unwrap();
    toast.success("Category Deleted Successfully", { autoClose: 200 });
    setIsDeleted(true);
    onClose();
  };
  return (
    <Modal show={!!id} centered>
      <Modal.Header>
        <div className="flex-between w-100">
          <Modal.Title>Delete</Modal.Title>
          <Close style="close-32 close" close={() => onClose()} img="Close" />
        </div>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete <strong>{deleteType}</strong> ?
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onClose()}
          text="Cancel"
          type={"default"}
        />
        <Button
        danger={true}
          type="default"
          text="Delete"
          onClick={() => Remove()}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default CategoryDeletePopup;
